<template>
  <div>
    <el-dialog class="dialogClass" width="60%" :title="title" :visible.sync="visible" :close-on-click-modal="false"
               @opened="openFun">
      <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
        <el-form-item v-show="false" prop="id">
          <el-input v-model="entity.id"></el-input>
        </el-form-item>
        <el-form-item label="方案名称" prop="name">
          <el-input v-model="entity.name" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="entity.code" placeholder="请输入编码"></el-input>
        </el-form-item>
        <el-form-item label="启停状态" prop="status">
          <el-radio-group v-model="entity.status">
            <el-radio v-for="item in $dict.map['start_stop']" :key="item.value" :label="item.value">{{
                item.name
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="执行步骤" prop="stepList">
          <div class="steps-section">
            <el-button v-if="hasPer('flow:design')" @click="openStepSelection"
                       style="margin-bottom: 10px;float: right;">新增步骤
            </el-button>
            <div>
              <el-table class="tablebox" :data="entity.stepList" row-key="id"
                        :height="entity.stepList.length<5 ? 'auto' : '350px'" border>
                <el-table-column fixed label="排序" prop="seq" width="80px">
                  <template slot-scope="scope">
                    <div class="seq-container">
                      <!--                <el-input-number v-model="scope.row.seq"-->
                      <!--                                 :min="0"-->
                      <!--                                 :max="entity.stepList.length"-->
                      <!--                                 controls-position="right"-->
                      <!--                                 @input.native="reorderSteps"-->
                      <!--                                 @change="reorderSteps"-->
                      <!--                                 @blur="reorderSteps"></el-input-number>-->
                      <p>{{ scope.row.seq }}</p>
                      <el-button-group class="seq-buttons">
                        <el-button type="text" @click="moveUp(scope.$index)">
                          <i class="el-icon-caret-top"></i>
                        </el-button>
                        <el-button type="text" @click="moveDown(scope.$index)">
                          <i class="el-icon-caret-bottom"></i>
                        </el-button>
                      </el-button-group>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column fixed label="步骤名称" prop="name"></el-table-column>
<!--                <el-table-column label="编码" prop="code"></el-table-column>-->
                <el-table-column label="审批职位" prop="apprpvalPosName"></el-table-column>
                <!--                <el-table-column label="审批人" prop="approvalUser"></el-table-column>-->
                <el-table-column label="条件节点" prop="isCondition" width="100px">
                  <template slot-scope="scope">
                    <p>{{ $dict.nameOf('yes_no', String(scope.row.isCondition)) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="执行条件" prop="condition">
                  <template slot-scope="scope">
                    <!--                    <el-input v-if="String(scope.row.isCondition) === '1'" v-model="scope.row.condition"-->
                    <!--                              placeholder=""></el-input>-->
                    <el-select v-if="String(scope.row.isCondition) === '1'" v-model="scope.row.condition"
                               placeholder="请选择条件" clearable>
                      <el-option v-for="item in flowConditions" :key="item.code"
                                 :label="item.name"
                                 :value="item.code">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="操作" prop="option" width="100px" align="center">
                  <template slot-scope="scope">
                    <div class="actions">
                      <!--            <el-button v-if="hasPer('flow:design')" type="primary" @click="editStep(scope.row)">编辑</el-button>-->
                      <el-button size="medium" v-if="hasPer('flow:design')" type="danger"
                                 @click="delStep(scope.$index, scope.row)">删除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
    </el-dialog>
    <!-- 步骤选择对话框 -->
    <el-dialog :title="stepDialogTitle" :visible.sync="stepDialogVisible" width="60%">
      <el-table :data="stepTableData" row-key="id" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="步骤顺序" prop="seq" width="100px"></el-table-column>
        <el-table-column label="步骤名称" prop="name"></el-table-column>
<!--        <el-table-column label="编码" prop="code"></el-table-column>-->
        <el-table-column label="审批职位" prop="apprpvalPosName"></el-table-column>
        <!--        <el-table-column label="审批人" prop="approvalUser"></el-table-column>-->
        <el-table-column label="条件节点" prop="isCondition">
          <template slot-scope="scope">
            <p>{{ $dict.nameOf('yes_no', String(scope.row.isCondition)) }}</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="stepDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addSelectedSteps">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {editFlowPlan, getFlowConditions, getFlowPlanStep, getFlowStepList} from "@/api/sys/flow/flow";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";

export default {
  name: "editFlowPlan",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    flowId: {
      type: [String, Number],
      require: true,
      default: ''
    },
    dataObj: Object
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible;
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val);
      }
    }
  },
  data() {
    return {
      title: '新增流程执行方案',
      isLoading: false,
      entity: {
        id: null,
        name: '',
        code: '',
        status: '',
        stepList: []
      },
      rules: {
        name: [{required: true, message: '方案名称不能为空', trigger: 'blur'},
          {max: 20, message: '方案名称长度不能超过50个字符', trigger: 'blur'}
        ],
        code: [{required: true, message: '编码不能为空', trigger: 'blur'},
          {max: 20, message: '编码长度不能超过20个字符', trigger: 'blur'}
        ],
        status: [{required: true, message: '启停状态不能为空', trigger: 'blur'}],
        stepList: [{required: true, message: '步骤不能为空', trigger: 'blur'},
          {type: 'array', min: 2, message: '步骤数不能小于2', trigger: 'blur'}
        ]
      },
      stepDialogVisible: false,
      stepDialogTitle: '选择步骤',
      stepTableData: [],
      selectedSteps: [],
      flowConditions: []
    };
  },
  mounted() {
    getFlowConditions().then(res => {
      this.flowConditions = res;
    })
  },
  methods: {
    hasPer,
    resetForm(ref) {
      this.$refs[ref].resetFields();
      this.entity = {
        id: null,
        name: '',
        code: '',
        status: '',
        stepList: []
      };
    },
    openFun() {
      this.title = this.dataObj.id ? '编辑' : "新增";
      this.entity = this.dataObj ? {...this.dataObj} : {
        id: null,
        flowId: this.dataObj.flowId,
        name: '',
        code: '',
        status: '',
        stepList: []
      };
      if (this.entity.id) {
        this.loadSteps();
      }
      this.entity.stepList = this.entity.stepList ? this.entity.stepList : [];
      this.$refs['flowRef'].clearValidate();
    },
    loadSteps() {
      getFlowPlanStep(this.entity.id).then(res => {
        this.entity.stepList = res.stepList ? res.stepList : [];
        this.reorderSteps();
        this.$forceUpdate()
      });
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          editFlowPlan(this.entity).then(() => {
            successMsg('操作成功');
            this.visible = false;
            this.$emit('get-list');
            this.isLoading = false;
          }).catch(() => {
            this.isLoading = false;
          });
        }
      });
    },
    // 打开步骤选择对话框
    openStepSelection() {
      getFlowStepList({flowId: this.entity.flowId}).then(res => {
        this.stepTableData = res;
        //过滤已经选择的步骤
        this.stepTableData = this.stepTableData.filter(step => !this.entity.stepList.some(s => s.id === step.id));
        this.stepDialogVisible = true;
      });
    },
    // 处理选择的步骤
    handleSelectionChange(selection) {
      this.selectedSteps = selection;
    },
    // 添加选中的步骤
    addSelectedSteps() {
      this.selectedSteps.forEach(step => {
        if (!this.entity.stepList.some(s => s.id === step.id)) {
          this.entity.stepList.push(step);
        }
      });
      this.stepDialogVisible = false;
      this.reorderSteps();
    },
    // 编辑步骤
    editStep() {
      // 这里可以打开一个编辑对话框来编辑步骤
      // 为了简化示例，直接在表格中编辑
    },
    // 删除步骤
    delStep(index, row) {
      this.$confirm('确定删除执行步骤【' + row.name + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.entity.stepList.splice(index, 1);
        this.reorderSteps();
      }).catch(() => {
        infoMsg('操作已取消')
      })

    },
    // 处理排序字段变化
    handleSeqChange() {
      this.reorderSteps();
    },
    // 重新排序步骤
    reorderSteps() {
      this.entity.stepList.sort((a, b) => a.seq - b.seq);
      // 自动调整排序字段
      this.entity.stepList.forEach((step, index) => {
        step.seq = index + 1;
      })
    },
    moveUp(index) {
      if (index > 0) {
        const seq = this.entity.stepList[index].seq;
        this.entity.stepList[index].seq = this.entity.stepList[index - 1].seq;
        this.entity.stepList[index - 1].seq = seq;
        this.reorderSteps();
      }
    },
    moveDown(index) {
      if (index < this.entity.stepList.length - 1) {
        const seq = this.entity.stepList[index].seq;
        this.entity.stepList[index].seq = this.entity.stepList[index + 1].seq;
        this.entity.stepList[index + 1].seq = seq;
        this.reorderSteps();
      }
    }
  },
};
</script>

<style scoped>
.dialogClass {
  .el-dialog__body {
    max-height: calc(100vh - 360px);
    overflow: auto;
  }
}


.seq-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.seq-buttons {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.seq-buttons .el-button {
  padding: 0;
  margin: 0;
}

.seq-buttons .el-button i {
  font-size: 16px;
}

.actions {
  display: flex;
}

.steps-section {
  margin-top: 10px;

  .tablebox {
    width: 100%;
    max-height: 800px;
    min-height: 300px;
    overflow-y: auto;
    position: relative;
    border-bottom: 1px solid #fff !important;

    ::v-deep.el-table::before {
      display: none !important;
    }

    ::v-deep(.el-table__body-wrapper) {
      overflow-x: scroll !important;
    }
  }
}


</style>

